import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import router from './router';
import sw from './locales/sw.json';
import en from './locales/en.json';
import './styles/index.css';

const i18n = createI18n({
  legacy: false,
  locale: 'sw',
  fallbackLocale: 'en',
  messages: { sw, en },
});

createApp(App)
  .use(createPinia())
  .use(router)
  .use(i18n)
  .mount('#app');
